export function isResidentNotificationsMockEnabled(): boolean {
  return process.env.NODE_ENV === 'development';
}

/** Добавьте `?mockNotifications=empty` в URL, чтобы проверить пустое состояние. */
export function isResidentNotificationsMockEmpty(): boolean {
  if (typeof window === 'undefined' || !isResidentNotificationsMockEnabled()) {
    return false;
  }

  return new URLSearchParams(window.location.search).get('mockNotifications') === 'empty';
}
